import App from "./components/App";
import { AppContainer } from "react-hot-loader";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import * as React from "react";
import * as ReactDOM from "react-dom";
import theme from "./theme";
import axiosBaseURL from "../../utilities/httpCommon";
//import process = require("process");

/* global document, Office module require console localStorage */
//axios.defaults.baseURL = "http://localhost:5000";
//axios.defaults.baseURL = process.env.REACT_APP_API_KEY;

initializeIcons();

let isOfficeInitialized = false;
let isLoggedin = false;

const title = "Amtrino Template";

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <ThemeProvider theme={theme}>
        <Component title={title} isOfficeInitialized={isOfficeInitialized} LoggedIn={isLoggedin} />
        <CssBaseline />
      </ThemeProvider>
    </AppContainer>,
    document.getElementById("container")
  );
};

/* Render application after Office initializes */
(async () => {
  await Office.onReady();
  isOfficeInitialized = false;
  try {
    await axiosBaseURL
      .get("/sfserver/auth/whoami", {
        withCredentials: true,
      })
      .then((res) => {
        isOfficeInitialized = true;
        console.log(res);
        if (res != null && res.data != "") {
          isLoggedin = true;
          localStorage.setItem("sfuserid", res.data.user_id);
        }
        console.log("initial Loaded");
        console.log(isLoggedin);
        render(App);
      })
      .catch(() => {
        isOfficeInitialized = true;
        isLoggedin = false;
        render(App);
      });
  } catch {
    isOfficeInitialized = true;
    isLoggedin = false;
    render(App);
  }
})();

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    render(NextApp);
  });
}
